import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private apiUrl = '/api/documents';

  constructor(private http: HttpClient) {}

  upload(file: File, isTemplate: boolean = false): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('isTemplate', String(isTemplate));
    return this.http.post(`${this.apiUrl}/upload`, formData);
  }

  getAllDocuments(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getDocument(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  getPdfUrl(id: string): string {
    return `${this.apiUrl}/${id}/pdf`;
  }

  getPdfBlob(id: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/pdf`, { responseType: 'blob' });
  }

  getAuditBlob(id: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/audit`, { responseType: 'blob' });
  }

  deleteDocument(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  addSigner(docId: string, signer: { name: string; email: string; phone?: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}/${docId}/signers`, signer);
  }

  deleteSigner(signerId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/signers/${signerId}`);
  }

  updateSigner(signerId: string, data: any): Observable<any> {
    return this.http.patch(`${this.apiUrl}/signers/${signerId}`, data);
  }

  updateSignerPosition(signerId: string, position: { x: number, y: number, page: number, width?: number, height?: number }) {
    return this.http.patch(`${this.apiUrl}/signers/${signerId}/position`, position);
  }

  sendInvitations(docId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${docId}/send-invitations`, {});
  }

  getSignerByToken(token: string, browserData?: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/sign/${token}`, { browserData });
  }

  confirmSignature(token: string, browserData?: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/sign/${token}/confirm`, { browserData });
  }

  sendWhatsAppCode(signerId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/sign/${signerId}/send-whatsapp`, {});
  }

  verifyWhatsAppCode(signerId: string, code: string, browserData?: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/sign/${signerId}/verify-whatsapp`, { code, browserData });
  }

  getSmtpSettings(): Observable<any> {
    return this.http.get(`${this.apiUrl}/settings/smtp`);
  }

  saveSmtpSettings(settings: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/settings/smtp`, settings);
  }

  testSmtp(email: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/settings/smtp/test`, { email });
  }

  getSigner2faQr(signerId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/sign/${signerId}/2fa-qr`);
  }

  verifySigner2fa(signerId: string, code: string, browserData?: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/sign/${signerId}/verify-2fa`, { code, browserData });
  }

  updateTextFields(docId: string, fields: any[]): Observable<any> {
    return this.http.post(`${this.apiUrl}/${docId}/text-fields`, fields);
  }
}
